/*
 * Recommended mattresses block.
 *
 * - Adds a mattress variant to cart via /cart/add.js without leaving the PDP.
 * - Re-fetches the block when the bed's selected variant changes, so the
 *   recommendations track the chosen variant's metafield.
 *
 * Button labels are read from data-* attributes so all copy stays localized
 * in Liquid. Initialised per wrapper; safe to run once globally.
 */
(function () {
  function initWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.mattressInit) return;
    wrapper.dataset.mattressInit = 'true';

    function bindAddButtons(root) {
      root.querySelectorAll('.recommended-mattresses__button').forEach(function (btn) {
        if (btn.dataset.bound || btn.disabled) return;
        btn.dataset.bound = 'true';

        btn.addEventListener('click', function () {
          var variantId = btn.dataset.variantId;
          if (!variantId) return;

          var labelAdd = btn.dataset.labelAdd || btn.textContent;
          var labelAdding = btn.dataset.labelAdding || labelAdd;
          var labelAdded = btn.dataset.labelAdded || labelAdd;

          btn.disabled = true;
          btn.textContent = labelAdding;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          })
            .then(function (res) { return res.json(); })
            .then(function () {
              btn.textContent = labelAdded;
              document.dispatchEvent(new CustomEvent('cart:refresh'));

              setTimeout(function () {
                btn.textContent = labelAdd;
                btn.disabled = false;
              }, 1500);
            })
            .catch(function (err) {
              console.error('Add to cart failed:', err);
              btn.textContent = labelAdd;
              btn.disabled = false;
            });
        });
      });
    }

    bindAddButtons(wrapper);

    var refreshTimeout = null;
    var lastVariantId = null;

    function refreshMattresses(variantId) {
      if (!variantId || variantId === lastVariantId) return;
      lastVariantId = variantId;

      clearTimeout(refreshTimeout);
      refreshTimeout = setTimeout(function () {
        var url = wrapper.dataset.productUrl + '?variant=' + variantId;

        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var newWrapper = parsed.querySelector('.recommended-mattresses-wrapper');
            if (newWrapper) {
              wrapper.innerHTML = newWrapper.innerHTML;
              bindAddButtons(wrapper);
            }
          })
          .catch(function (err) {
            console.error('Mattress refresh failed:', err);
          });
      }, 150);
    }

    // Sleek theme (Foxecom) fires 'variant:changed' with evt.detail.variant.
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.id) refreshMattresses(v.id);
    });

    // Fallback: watch the product form's hidden variant input directly.
    var form = document.querySelector('form[action^="/cart/add"]');
    if (form) {
      var hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        var observer = new MutationObserver(function () {
          refreshMattresses(hiddenInput.value);
        });
        observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

        form.addEventListener('click', function () {
          setTimeout(function () { refreshMattresses(hiddenInput.value); }, 300);
        });
      }
    }
  }

  function init() {
    document.querySelectorAll('.recommended-mattresses-wrapper').forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
